import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { Breadcrumbs } from "../../../components/Breadcrumbs";
import { useTranslation } from "react-i18next";
import { RefreshButton } from "../../../components/RefreshButton";
import { ExportButton } from "../../../components/ExportButton";

const Header = ({ onDownload, onRefresh }) => {
  const { t } = useTranslation();
  const currentPath = [{ name: t("Lpr events"), url: "/app/lpr-events" }];

  return (
    <Grid container spacing={3} justifyContent="space-between">
      <Breadcrumbs path={currentPath} />
      <Grid item>
        <RefreshButton onClick={onRefresh} />
        <ExportButton onClick={onDownload} />
      </Grid>
    </Grid>
  );
};

Header.propTypes = {
  className: PropTypes.string,
};

export default Header;
